import React from 'react';
import type {
  RiskFactorDetailViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const RiskFactorDetails = withErrorBoundary(
  React.lazy(
    () => import('../../../micro-frontends/components/RiskFactorDetails'),
  ),
);

export const RiskFactorDetailsView = (props: RiskFactorDetailViewProps) => {
  return <RiskFactorDetails {...props.data} />;
};
